import * as E from 'linq';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { throwError } from 'rxjs';

import { ShowToastAction } from 'src/storage/application/application.actions';
import { IStore } from 'src/storage/store';
import { ToastSeverity } from 'src/app/shared/components/toast/toast';

@Injectable()
export class ResponseInterceptor implements HttpInterceptor {
  constructor(private store: Store<IStore>) {}

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    const httpClientErrorHandler = (error: any) => {
      const url = error?.url ? new URL(error.url) : null;
      const domain = url?.hostname;
      if(domain != "apiv2.owler.com"){
    /*  if (error instanceof HttpErrorResponse
                && error.status == 401) {

             //   window.location.reload();
            }*/

            if (error instanceof HttpErrorResponse && !error.url?.includes('openid-configuration')
            ) {
              let err = error.error;

              if (this.IsJsonString(error.error)) {
                err = JSON.parse(error.error);
              }

              this.store.dispatch(
                ShowToastAction({
                  toast: {
                    text: err && err[0] && err[0].message || error.statusText,
                    //text: error && error.error[0]?.message || error.error && error.error[0] && error.error[0].message || error.statusText,
                    severity: ToastSeverity.DANGER,
                  },
                })
              );
              return throwError(error);
            }
      }

      return throwError(error);

    };

    return next
      .handle(request)
      .pipe(catchError((error) => httpClientErrorHandler(error)));
  }
  IsJsonString(str): boolean {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  }
}
